import { usePlatformComponentContext } from '../../contexts/platform-component.context';
import { BooleanSwitch } from './boolean-switch';

export type PublicSwitchProps<T extends object> = React.PropsWithChildren<{
  publicContent: React.FC<T>;
  authenticatedContent: React.FC<T>;
  propsToBind: T;
}>;

export function PublicSwitch<T extends object>({
  children,
  publicContent,
  authenticatedContent,
  propsToBind,
}: PublicSwitchProps<T>) {
  const { isPublic } = usePlatformComponentContext();

  return (
    <BooleanSwitch
      value={isPublic}
      trueContent={publicContent}
      falseContent={authenticatedContent}
      propsToBind={propsToBind}
    >
      {children}
    </BooleanSwitch>
  );
}
